<template>
  <div class="NeedsApproval">
    <div class="filter-container" />
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <el-table-column :label="$t('customerService.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.creator')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.operate_user_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.reference')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.reference_batch_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.submit_quantity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.submit_quantity }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.success_quantity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.success_quantity }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.pending_quantity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.pending_quantity }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.fail_quantity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fail_quantity }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.total_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.amount | toThousandFilter }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">

            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function " icon-class="operation-detail" @click="onClickDetailBtn(scope.row.reference_batch_no)" />
            </el-tooltip>

            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.download') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function operation-download" icon-class="operation-download" @click="onClickDowmloadBtn(scope.row)" />
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
    </div>
  </div>

</template>

<script>

import { fetchPaymentAllRefernceData, fetchPaymentRefernceDetailWithTrans } from '@/api/online-transaction/online-transaction'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { payTransactionStatusMap } from '@/utils/maps'
export default {
  name: 'Payment_Approved',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      listLoading: false,
      submiting: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    getPOTransactionStatusType() {
      return function(value) {
        return payTransactionStatusMap(value).type
      }
    },
    getPOTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusMap(value).label
      }
    }
  },
  created() {
    this.getAllReferenceInfo()
  },
  methods: {
    getAllReferenceInfo(otherParams) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      fetchPaymentAllRefernceData(params).then(res => {
        if (res.code === 10000) {
          const { total, records = [], current } = res.data
          this.listQuery.total = total
          this.listQuery.page = current
          this.tableData = records
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      let params = { type: 1, status: 1, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    onClickDetailBtn(reference_batch_no) {
      this.$router.push({ name: 'Online_Transaction_Detail_Payin', params: { id: reference_batch_no, status: 1 }})
    },
    onClickDowmloadBtn(row) {
      if (this.downloading) {
        return
      }
      this.downloading = true
      const params = {
        reference_batch_no: row.reference_batch_no
      }
      fetchPaymentRefernceDetailWithTrans(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Start downloading!')
          this.handleXlsxData(res.data).then((downloadData) => {
            exportXlsx(downloadData, 'Payin_Refernce')
          })
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 2000)
      })
    },
    handleXlsxData(data = []) {
      const rows = [[
        this.$t('customerService.payment_method'),
        this.$t('customerService.payment_channel'),
        this.$t('customerService.reference'),
        this.$t('components.amount'),
        this.$t('customerService.customer_name'),
        this.$t('components.email'),
        this.$t('customerService.email_content'),
        this.$t('data.remark'),
        this.$t('components.status'),
        this.$t('components.link')
      ]]

      const toDivide100 = this.$options.filters['toDivide100']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.payment_type,
            tr.channel_code,
            tr.reference_batch_no,
            tr.amount && Number(tr.amount),
            tr.customer_name,
            tr.email,
            tr.email_description,
            tr.remark,
            this.getPOTransactionStatusMap(tr.transaction_status),
            tr.redirect_url
          ])
        })
      }
      return Promise.resolve(rows)
    },

    onClickPaginator() {

      this.getAllReferenceInfo(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.NeedsApproval{
   background-color: #fff;
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px;
  }
  .btn-container{
    display: flex;
    justify-content: flex-end;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}

</style>
